export enum ContactDetailsFormField {
  Email = 'email',
  MarketingPreferenceEmail = 'marketingPreferenceEmail',
  MarketingPreferencePost = 'marketingPreferencePost',
  Phone = 'phone',
}
